import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, withModifiers as _withModifiers, createElementVNode as _createElementVNode, openBlock as _openBlock, createBlock as _createBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = {
  class: "mockExamlist"
};
const _hoisted_2 = {
  class: "dialog-footer"
};
const _hoisted_3 = {
  class: "dialog-footer"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_el_button = _resolveComponent("el-button");
  const _component_el_row = _resolveComponent("el-row");
  const _component_el_table_column = _resolveComponent("el-table-column");
  const _component_el_table = _resolveComponent("el-table");
  const _component_el_input = _resolveComponent("el-input");
  const _component_el_form_item = _resolveComponent("el-form-item");
  const _component_el_option = _resolveComponent("el-option");
  const _component_el_select = _resolveComponent("el-select");
  const _component_el_form = _resolveComponent("el-form");
  const _component_el_dialog = _resolveComponent("el-dialog");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_el_row, {
    class: "flex items-center pd12 wbg ft14"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_button, {
      icon: "Plus",
      type: "primary",
      onClick: $options.createPaper
    }, {
      default: _withCtx(() => [_createTextVNode("新建试卷")]),
      _: 1
    }, 8, ["onClick"])]),
    _: 1
  }), _createVNode(_component_el_row, {
    class: "pd12 wbg mt12 flex flex-col"
  }, {
    default: _withCtx(() => [_createVNode(_component_el_table, {
      data: $data.paperList,
      style: {
        "width": "100%"
      },
      ref: "table"
    }, {
      default: _withCtx(() => [_createVNode(_component_el_table_column, {
        prop: "paperName",
        label: "名称"
      }), _createVNode(_component_el_table_column, {
        prop: "paperType",
        label: "类型"
      }), _createVNode(_component_el_table_column, {
        prop: "unitCount",
        label: "单元数量"
      }), _createVNode(_component_el_table_column, {
        prop: "duration",
        label: "试卷时长"
      }), _createVNode(_component_el_table_column, {
        prop: "unit1",
        label: "第一单元",
        width: "200"
      }), _createVNode(_component_el_table_column, {
        prop: "unit2",
        label: "第二单元",
        width: "200"
      }), _createVNode(_component_el_table_column, {
        prop: "unit3",
        label: "第三单元",
        width: "200"
      }), _createVNode(_component_el_table_column, {
        prop: "updatedTime",
        label: "更新时间"
      }), _createVNode(_component_el_table_column, {
        fixed: "right",
        label: "Operations",
        "min-width": "120"
      }, {
        default: _withCtx(scope => [_createVNode(_component_el_button, {
          link: "",
          type: "primary",
          size: "small",
          onClick: $event => $options.handelPaperEdit(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(" 编辑试卷 ")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          size: "small",
          onClick: $event => $options.handelUnitEdit(scope.row)
        }, {
          default: _withCtx(() => [_createTextVNode(" 编辑单元 ")]),
          _: 2
        }, 1032, ["onClick"]), _createVNode(_component_el_button, {
          link: "",
          type: "primary",
          size: "small",
          onClick: _withModifiers($event => $options.handelDelete(scope.row), ["prevent"])
        }, {
          default: _withCtx(() => [_createTextVNode(" 删除 ")]),
          _: 2
        }, 1032, ["onClick"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["data"])]),
    _: 1
  }), _createVNode(_component_el_dialog, {
    modelValue: $data.paperDialogFormVisible,
    "onUpdate:modelValue": _cache[5] || (_cache[5] = $event => $data.paperDialogFormVisible = $event),
    title: "试卷"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_2, [_createVNode(_component_el_button, {
      onClick: _cache[4] || (_cache[4] = $event => $data.paperDialogFormVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.createSavePaper
    }, {
      default: _withCtx(() => [_createTextVNode(" 保存 ")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.form
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "试卷名称"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.paperName,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => $data.form.paperName = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "试卷类型"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.form.paperType,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => $data.form.paperType = $event)
        }, {
          default: _withCtx(() => [_createVNode(_component_el_option, {
            key: "INITIAL",
            label: "初试",
            value: "INITIAL"
          }), _createVNode(_component_el_option, {
            key: "RETAKE",
            label: "复试",
            value: "RETAKE"
          })]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "试卷单元数量"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.unitCount,
          "onUpdate:modelValue": _cache[2] || (_cache[2] = $event => $data.form.unitCount = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "试卷时长(分钟)"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.form.duration,
          "onUpdate:modelValue": _cache[3] || (_cache[3] = $event => $data.form.duration = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue"]), _createVNode(_component_el_dialog, {
    modelValue: $data.unitDialogFormVisible,
    "onUpdate:modelValue": _cache[12] || (_cache[12] = $event => $data.unitDialogFormVisible = $event),
    title: "编辑单元",
    width: "500"
  }, {
    footer: _withCtx(() => [_createElementVNode("div", _hoisted_3, [_createVNode(_component_el_button, {
      onClick: _cache[11] || (_cache[11] = $event => $data.unitDialogFormVisible = false)
    }, {
      default: _withCtx(() => [_createTextVNode("取消")]),
      _: 1
    }), _createVNode(_component_el_button, {
      type: "primary",
      onClick: $options.createSaveUnit
    }, {
      default: _withCtx(() => [_createTextVNode(" 保存 ")]),
      _: 1
    }, 8, ["onClick"])])]),
    default: _withCtx(() => [_createVNode(_component_el_form, {
      model: $data.unitForm
    }, {
      default: _withCtx(() => [_createVNode(_component_el_form_item, {
        label: "单元名称"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.unitForm.unitName,
          "onUpdate:modelValue": _cache[6] || (_cache[6] = $event => $data.unitForm.unitName = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "单元序号"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_select, {
          modelValue: $data.unitForm.unitOrder,
          "onUpdate:modelValue": _cache[7] || (_cache[7] = $event => $data.unitForm.unitOrder = $event)
        }, {
          default: _withCtx(() => [(_openBlock(), _createBlock(_component_el_option, {
            key: 1,
            label: "第一单元",
            value: 1
          })), (_openBlock(), _createBlock(_component_el_option, {
            key: 2,
            label: "第二单元",
            value: 2
          })), (_openBlock(), _createBlock(_component_el_option, {
            key: 3,
            label: "第三单元",
            value: 3
          }))]),
          _: 1
        }, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "单元时长"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.unitForm.duration,
          "onUpdate:modelValue": _cache[8] || (_cache[8] = $event => $data.unitForm.duration = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "单元题目数量"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.unitForm.questionCount,
          "onUpdate:modelValue": _cache[9] || (_cache[9] = $event => $data.unitForm.questionCount = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      }), _createVNode(_component_el_form_item, {
        label: "单元题目模版ID"
      }, {
        default: _withCtx(() => [_createVNode(_component_el_input, {
          modelValue: $data.unitForm.questionTplId,
          "onUpdate:modelValue": _cache[10] || (_cache[10] = $event => $data.unitForm.questionTplId = $event),
          autocomplete: "off"
        }, null, 8, ["modelValue"])]),
        _: 1
      })]),
      _: 1
    }, 8, ["model"])]),
    _: 1
  }, 8, ["modelValue"])]);
}